import { ChainIdLegacy, ChainKey, getChainKey, isChainId, isEnvVarOn } from '@silo/types';

const LIQUIDATION_WARNING_ENABLED: Record<ChainKey, boolean> = {
  ethereum: isEnvVarOn(() => process.env.NEXT_PUBLIC_LIQUIDATION_WARNING_MAINNET),
  arbitrum: isEnvVarOn(() => process.env.NEXT_PUBLIC_LIQUIDATION_WARNING_ARBITRUM),
  optimism: isEnvVarOn(() => process.env.NEXT_PUBLIC_LIQUIDATION_WARNING_OPTIMISM),
  base: isEnvVarOn(() => process.env.NEXT_PUBLIC_LIQUIDATION_WARNING_BASE),
  anvil: true,
  local: true,
};

export function getIsLiquidationWarningEnabled(chainId?: ChainIdLegacy): boolean {
  if (!isChainId(chainId)) return false;

  const chainKey = getChainKey(chainId);

  return LIQUIDATION_WARNING_ENABLED[chainKey];
}
